/**
 * Display names for the support groups.
 *
 * The group is derived from the URL segment, which is a slug rather than a
 * label — `hubspot-integration` should read as "HubSpot Integration", and
 * title-casing alone gets the product names wrong.
 */
const LABELS: Record<string, string> = {
  product: 'Product',
  'hubspot-integration': 'HubSpot Integration',
  'instantly-integration': 'Instantly Integration',
  'zapier-integration': 'Zapier Integration',
  copywriting: 'Copywriting',
  resources: 'Resources',
}

/**
 * The one-line description under each group heading on the support index.
 * Verbatim from the live site; the Webflow capture had dropped these.
 */
const DESCRIPTIONS: Record<string, string> = {
  product: 'Learn how to use Singulate\u2019s key features.',
  'hubspot-integration': 'Connect and sync your HubSpot data.',
  'instantly-integration':
    'Send hyper-personalized cold outreach campaigns right from your Instantly account.',
  'zapier-integration': 'Create hyper-personalized Gmail campaigns sent with a Zap.',
  copywriting: 'Write clear, personalized emails that convert.',
  resources: 'Grab templates and tools to move faster.',
}

export function groupDescription(group: string): string | null {
  return DESCRIPTIONS[group] ?? null
}

export function groupLabel(group: string | null): string {
  if (!group) return 'Support'
  return LABELS[group] ?? group.replace(/-/g, ' ').replace(/\b\w/g, (c) => c.toUpperCase())
}

/** Order the groups appear in on the support index. */
export const GROUP_ORDER = [
  'product',
  'hubspot-integration',
  'instantly-integration',
  'zapier-integration',
  'copywriting',
  'resources',
]
